module.exports = __webpack_public_path__ + "site/img/53.037ed645.jpg";